<cloud-manage-grid (onShowDevices)="onShowDevices($event)"></cloud-manage-grid>

<mat-expansion-panel [hidden]="!selectedCert" [expanded]="expandList">
  <mat-expansion-panel-header>
    <mat-panel-title>{{'manageTexts.devicesToCert' | translate}}{{selectedCert?.serialNo}}</mat-panel-title>
  </mat-expansion-panel-header>
  <cloud-devices-grid [selectedCert]="selectedCert" [hidden]="!showDeviceList" isSubcomponent="true"></cloud-devices-grid>
</mat-expansion-panel>
